var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormEndereco',{on:{"recursos":function($event){_vm.recurso.enderecos = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }